import React from 'react'
import styled from '@emotion/styled'
import { css, useTheme } from '@emotion/react'
import { collisionLabelTextForUsers } from 'util/agents'
import { Avatar, Tooltip } from 'shared/ui'

function backgroundColorForType({ type, theme }) {
  switch (type) {
    case 'noting':
    case 'typingNote':
      return theme.color.primary.warning
    case 'typingReply':
    case 'replying':
    case 'viewing':
    default:
      return theme.color.primary.positive
  }
}

function colorForType({ type, theme }) {
  return ['noting', 'typingNote'].includes(type)
    ? theme.color.monochrome.black
    : theme.color.monochrome.white
}

function ellipsisForType(type) {
  // only show on edit action
  switch (type) {
    case 'typingReply':
    case 'typingNote':
    case 'replying':
    case 'noting':
      return <span>...</span>
    case 'viewing':
    default:
      return null
  }
}

const ChipLabel = styled('span')`
  position: relative;
  top: -1px;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${colorForType};
`

function labelForUsers(users, type) {
  if (!users || (users && users.length <= 0)) return null
  return (
    <ChipLabel type={type}>
      {collisionLabelTextForUsers(users, type)}
      {ellipsisForType(type)}
    </ChipLabel>
  )
}

const Container = styled('div')`
  display: flex;
  align-items: center;
  background-color: ${backgroundColorForType};
  border-radius: ${props => props.theme.spacing['3']};
  overflow: hidden;
`

const label = () => theme => css`
  padding: ${theme.spacing['5']};
  padding-right: ${theme.spacing['10']};
  white-space: nowrap;
`

export default function AgentsChip({ users, type }) {
  const [firstUser, ...restUsers] = users
  const theme = useTheme()
  const avatarBackground = backgroundColorForType({ type, theme })
  const color = colorForType({ type, theme })

  return (
    <Container type={type}>
      <Avatar
        actor={firstUser}
        size={32}
        radius={0}
        initialsBackground={avatarBackground}
        initialsColor={color}
        initialsBorderRight
      />
      <Tooltip
        position="top"
        css={label}
        tooltip={
          restUsers.length >= 1 && restUsers.map(user => user.name).join(', ')
        }
      >
        {labelForUsers(users, type)}
      </Tooltip>
    </Container>
  )
}
